const readCoord = (box, keys) => {
  for (const key of keys) {
    if (box[key] == null || box[key] === "") continue;
    const value = Number(box[key]);
    if (Number.isFinite(value)) return value;
  }
  return null;
};

export const readRawSheetBox = (box) => {
  if (!box) return null;
  let value = box;
  if (typeof value === "string") {
    try {
      value = JSON.parse(value);
    } catch {
      return null;
    }
  }
  if (typeof value !== "object") return null;
  const topLeftX = readCoord(value, ["topLeftX", "top_left_x"]);
  const topLeftY = readCoord(value, ["topLeftY", "top_left_y"]);
  const bottomRightX = readCoord(value, ["bottomRightX", "bottom_right_x"]);
  const bottomRightY = readCoord(value, ["bottomRightY", "bottom_right_y"]);
  if (
    [topLeftX, topLeftY, bottomRightX, bottomRightY].some((coord) => coord == null)
  ) {
    return null;
  }
  return {
    topLeftX,
    topLeftY,
    bottomRightX,
    bottomRightY,
    source: value.source || null,
  };
};

const clamp01 = (value) => Math.min(1, Math.max(0, value));

export const parseSheetBox = (box, pageSize) => {
  const raw = readRawSheetBox(box);
  if (!raw) return null;

  let { topLeftX, topLeftY, bottomRightX, bottomRightY } = raw;
  const max = Math.max(topLeftX, topLeftY, bottomRightX, bottomRightY);
  const pageWidth = Number(pageSize?.width);
  const pageHeight = Number(pageSize?.height);
  const hasPageSize =
    Number.isFinite(pageWidth) &&
    Number.isFinite(pageHeight) &&
    pageWidth > 0 &&
    pageHeight > 0;

  if (max > 1.5 && max <= 100) {
    topLeftX /= 100;
    topLeftY /= 100;
    bottomRightX /= 100;
    bottomRightY /= 100;
  } else if (max > 1.5 && hasPageSize) {
    topLeftX /= pageWidth;
    topLeftY /= pageHeight;
    bottomRightX /= pageWidth;
    bottomRightY /= pageHeight;
  } else if (max > 1.5) {
    return null;
  }

  const left = clamp01(Math.min(topLeftX, bottomRightX));
  const right = clamp01(Math.max(topLeftX, bottomRightX));
  const top = clamp01(Math.min(topLeftY, bottomRightY));
  const bottom = clamp01(Math.max(topLeftY, bottomRightY));
  if (right - left <= 0 || bottom - top <= 0) return null;
  return padHighlightBox({
    topLeftX: left,
    topLeftY: top,
    bottomRightX: right,
    bottomRightY: bottom,
    source: raw.source,
  });
};

export const padHighlightBox = (parsed) => {
  if (!parsed) return null;
  const height = parsed.bottomRightY - parsed.topLeftY;
  const width = parsed.bottomRightX - parsed.topLeftX;
  if (height <= 0 || width <= 0) return parsed;
  if (height > 0.02) return parsed;
  const pad = Math.min(0.004, Math.max(height * 0.25, 0.0015));
  return {
    ...parsed,
    topLeftY: clamp01(parsed.topLeftY - pad),
    bottomRightY: clamp01(parsed.bottomRightY + pad),
  };
};

export const displaySheetPage = (sourcePage) =>
  sourcePage == null || sourcePage === ""
    ? null
    : Number(sourcePage) + 1;
